export default "__VITE_ASSET__h89mUih6__"